import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=0e225ad1&scoped=true"
import script from "./step2.vue?vue&type=script&lang=js"
export * from "./step2.vue?vue&type=script&lang=js"
import style0 from "./step2.vue?vue&type=style&index=0&id=0e225ad1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e225ad1",
  null
  
)

export default component.exports